import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Paper, TablePagination } from '@material-ui/core';
import MaterialTable from 'material-table';
import { getString, rounded } from '../../../utils.js'
import CoocSpecPopup  from './CoocSpecPopup.js';
import CoocSimPopup  from './CoocSimPopup.js';
import { Button, Dialog } from '@blueprintjs/core';
import '../results.css';
import {estimatedClass} from '../common'
import { PUBLIC_URL, ANALYTICS_URL } from '../../../constants.js';
import Chart from 'react-apexcharts';
import {MAX_CHART_SIZE} from '../../../constants.js';

class CooccurrenceTab extends React.PureComponent {

  constructor(props) {
    super(props);
    
    this.state = { 
      isOpenModal:false,
      nodeWord:"",
      colloc:"",
      simPopup:false,
      simData:{},
      currentKey:0 // the current key for the coocSpec chart
    };
  }
  coocSpecPopup = (e) => {
    this.setState({currentKey:e.target.value, simPopup:false});
    this.toggleModal();
  };

  coocSimPopup = (e) => {
    const coocLine=this.props.cooc[e.target.value];
    const data={ node_word:coocLine[0],entry:coocLine[1],rels:coocLine[7],session_id:this.props.sessionId, corpus_id:this.props.subCorpus }
    const endpoint = '/similarCooc.ajax.php';
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      }
    )
    .then((res) => {
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        return;
      }
      res.json().then((data) => {
        this.setState({nodeWord:coocLine[0],colloc:data.colloc,simData:data.simData,simPopup:true});
        this.toggleModal();
      })
    })
    .catch(() => {
      console.log(`Network eror when trying to fetch ${endpoint}`);
    })
    

  };


  toggleModal = () => {
    this.setState(prevState => ({ isOpenModal: !prevState.isOpenModal }));
  }

  prepTableRow = (row,i) => {
    if (this.props.displaySpec) {
      return {
        'exp': getString(row[0]),
        'coll': getString(row[1]),
        'numCooc': row[2],
        'numPivotOcc': row[3],
        'numCollOcc': row[4],
        'numRelOcc': row[5],
        'disp': row[6],
        'rel': getString(row[7]),
        'assoc': row[8],
        'spec': row[10],
        'compare': 
          <>
            <button value={row[0]+"\t"+row[1]} onClick={this.coocSpecPopup}>spec</button>
            <button value={i} onClick={this.coocSimPopup}>sim</button>
          </>,
      };
    // for global tab, no spec values
    } else {
      return {
        'exp': getString(row[0]),
        'coll': getString(row[1]),
        'numCooc': row[2],
        'numPivotOcc': row[3],
        'numCollOcc': row[4],
        'numRelOcc': row[5],
        'disp': row[6],
        'rel': getString(row[7]),
        'assoc': row[8],
        'compare': <button value={i} onClick={this.coocSimPopup}>sim</button>,

      };
     }
  }

  calcColloc = (coll) => {
    var lemma=".*";
    var cat=".*";
    if (coll.match(/\bl=([^,]+)/)) {
      lemma=RegExp.$1;
    }
    if (coll.match(/\bc=([^,]+)/)) {
      cat=RegExp.$1;
    }
    return lemma+'_'+cat;
  }

  calcLink = (exp,coll) => {
    //const urlParams = new URLSearchParams(window.location.search);
    //const sessionParam= (urlParams.get('session_id'))?"&session_id="+urlParams.get('session_id'):"";
    var query="";
    if (this.props.collocQuery) {
      query=this.props.collocQuery[coll];
    } else {
      console.log(exp+" "+coll+" pas trouvé");
    }
    const queryParams = "query=" + encodeURIComponent(query) + "&session_id=" + this.props.sessionId;
    return PUBLIC_URL + ANALYTICS_URL + "?" + queryParams;
  }
 
  render() {
    const { t, displaySpec, estimatedResults } = this.props;
    const { isOpenModal} = this.state;
    const tableRows = this.props.cooc.map((row,i) => this.prepTableRow(row,i));

    let columnDefinition;

    // prep data for the chart
    let data = [];
    for (const i in this.props.cooc) {
      const row=this.props.cooc[i];
      const chartRow = {
        colloc: this.calcColloc(row[1]),
        value: row[8],
      };
      data.push(chartRow);
      // console.log(row[1]+" "+row[8]);
    }

    // sort data by decreasing order
    data.sort((a, b) => a.value - b.value);
    data.reverse();
    const dataChart=data.slice(0,MAX_CHART_SIZE);


    const series = [{
      name:'assoc',
      data:dataChart.map(e=>e.value)
    }];
    const options = {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          columnWidth: '80%',
        }
      },
      dataLabels: {
        enabled: false,
      },
      yaxis: {
        title: {
          text: 'assoc',
        },
        labels: {
          formatter: function (y) {
            return rounded(y,2);
          }
        }
      },
      xaxis: {
        type: 'text',
        categories: dataChart.map(el=>(el.colloc)),
        labels: {
          rotate: -90
        }
      }
    }

    if (displaySpec) {
      columnDefinition=[
        { title: t('expression'), field: 'exp' },
        { title: t('collocate'), field: 'coll', render: rowData => <Button minimal small onClick={()=> { this.props.performSearch({query:this.props.collocQuery[rowData.coll]})} } >{this.calcColloc(rowData.coll)}</Button> },
        { title: t('coocNum'), field: 'numCooc', render: rowData => <span className={estimatedClass(rowData.numCooc,estimatedResults)}>{rounded(rowData.numCooc)}</span> },
        { title: t('pivotOccNum'), field: 'numPivotOcc', render: rowData => <span className={estimatedClass(rowData.numPivotOcc,estimatedResults)}>{rounded(rowData.numPivotOcc)}</span> },
        { title: t('collOccNum'), field: 'numCollOcc', render: rowData => <span className={estimatedClass(rowData.numCollOcc,estimatedResults)}>{rounded(rowData.numCollOcc)}</span> },
        { title: t('relOccNum'), field: 'numRelOcc', render: rowData => <span className={estimatedClass(rowData.numRelOcc,estimatedResults)}>{rounded(rowData.numRelOcc)}</span> },
        { title: t('dispersion'), field: 'disp' },
        { title: t('relations'), 
          field: 'rel',
          render: rowData => <div style={{height:'40px',overflowY:'auto'}} >{rowData.rel}</div>,
          cellStyle: {
            width:'120px',
            fontSize:'10px'
          }
        },        
        { title: t('assoc'), field: 'assoc', defaultSort:'desc' },
        { title: t('spec'), field: 'spec' },
        { title: t('compare'), field: 'compare' },
      ];
    } else {
      // for global tab, no spec
      columnDefinition=[
        { title: t('expression'), field: 'exp' },
        // { title: t('collocate'), field: 'coll', render: rowData => <a href={this.calcLink(rowData.exp,rowData.coll)} target='blank'>{this.calcColloc(rowData.coll)}</a> },
        { title: t('collocate'), field: 'coll', render: rowData => <Button minimal small onClick={() => { this.props.performSearch({query:this.props.collocQuery[rowData.coll]})} } >{this.calcColloc(rowData.coll)}</Button> },
        { title: t('coocNum'), field: 'numCooc', render: rowData => <span className={estimatedClass(rowData.numCooc,estimatedResults)}>{rounded(rowData.numCooc)}</span> },
        { title: t('pivotOccNum'), field: 'numPivotOcc', render: rowData => <span className={estimatedClass(rowData.numPivotOcc,estimatedResults)}>{rounded(rowData.numPivotOcc)}</span> },
        { title: t('collOccNum'), field: 'numCollOcc', render: rowData => <span className={estimatedClass(rowData.numCollOcc,estimatedResults)}>{rounded(rowData.numCollOcc)}</span> },
        { title: t('relOccNum'), field: 'numRelOcc', render: rowData => <span className={estimatedClass(rowData.numRelOcc,estimatedResults)}>{rounded(rowData.numRelOcc)}</span> },
        { title: t('dispersion'), field: 'disp' },
        { title: t('relations'), 
          field: 'rel',
          render: rowData => <div style={{height:'40px',overflowY:'auto'}} >{rowData.rel}</div>,
          cellStyle: {
            width:'120px',
            fontSize:'10px'
          }
        },
        { title: t('assoc'), field: 'assoc', defaultSort:'desc' },
        { title: t('compare'), field: 'compare' },
      ];
    }

   
    return (
      <>
        { this.props.displayName &&
          <div style={{color:"green",marginBottom:"20px"}}>{t('subCorpusName')} : {this.props.subCorpus}</div>
        }       
        <div id="chart">
            <Chart options={options} series={series} type="bar" height={350} />
        </div>

        <div className="margin-top-2-rem">
          <MaterialTable
            title={t('cooc')}
            columns={columnDefinition}
            data={tableRows}
            options={{
              filtering: true,
              search: true,
              sorting: true,
              exportButton: true,
              exportFile: 'cooccurrences',
              exportAlldata: true,
              rowStyle: {
                height:'40px',
                maxHeight:'40px',
              },
              pageSize:10,
              padding: 'dense',
             // tableLayout: 'fixed',
            }}
            components={{
              Pagination: props => (
                <TablePagination
                  {...props}
                  rowsPerPageOptions={[ 10, 25, 50, 100, tableRows.length ]}
                />
              ),
              Container: props => (
                <Paper
                  {...props}
                  elevation={0}
                />
              ),
            }}
          />
        </div>

        <Dialog
            isOpen={isOpenModal}
            onClose={this.toggleModal}
            title={t('coocComparisonBtn')}
            style={{'width': '800px'}}  // 800px seems a good deal
        >
          { ! this.state.simPopup && 
            <CoocSpecPopup colloc={this.state['currentKey']} data={this.props.coocSpec[this.state['currentKey']]}/>
          }
          {  this.state.simPopup && 
            <CoocSimPopup nodeWord={this.state.nodeWord} colloc={this.state.colloc} simData={this.state.simData} />
          }
        </Dialog>
      </>
    ); 
  }
}

CooccurrenceTab.propTypes = {
  // see prepCoocData for an example
  displayName: PropTypes.bool,
  sessionId: PropTypes.string,
  subCorpus: PropTypes.string, // name (dans les autre composants)
  cooc: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.any)),
  coocSpec:  PropTypes.object,
  collocQuery: PropTypes.object,
  displaySpec : PropTypes.bool,
  estimatedResults : PropTypes.bool,
  performSearch: PropTypes.func,
};

export default withTranslation()(CooccurrenceTab);
